// useTheme.js — Composable único de tema para toda la app
//
// Uso:
//   import { useTheme } from '@/composables/useTheme';
//   const { theme, toggleTheme } = useTheme();
//
// El theme se guarda en localStorage como 'theme' = 'light' | 'dark'.
// Default: dark (Bloomberg).

import { ref, watch } from 'vue';

// Estado global (singleton). Si lo importan 3 componentes, todos comparten el mismo ref.
const theme = ref(localStorage.getItem('theme') || 'dark');

// Aplicar tema en el <html> al cargar
function applyTheme(value) {
  document.documentElement.setAttribute('data-theme', value);
  localStorage.setItem('theme', value);
}

// Aplicar inmediatamente con el valor actual (en caso de primera carga)
applyTheme(theme.value);

// Sincronizar cambios con el DOM
watch(theme, (newValue) => {
  applyTheme(newValue);
});

export function useTheme() {
  function toggleTheme() {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
  }

  function setTheme(value) {
    if (value === 'light' || value === 'dark') {
      theme.value = value;
    }
  }

  return {
    theme,        // ref reactivo, .value para leer
    toggleTheme,  // alterna light <-> dark
    setTheme,     // setea explícitamente
  };
}